<template>
  <wp-items-list
    content-type="pages"
    content-type-singular="page"
    content-name="Pages"
    content-name-singular="Page"
  />
</template>

<script>
import WpItemsList from '@/views/wp-item/wp-items-list/WpItemsList.vue'

export default {
  components: {
    WpItemsList,
  },
}
</script>

<style scoped>

</style>
